import PropTypes from 'prop-types';

export default function Footer({ resetToFirstScreen }) {
  return (
    <>
      <div id='bf-chat-window-footer'>
        <div className='wrapper'>
          <div className='row'>
            <div className='col'>
              <div className='reset-wrapper'>
                <button
                  type='button'
                  onClick={resetToFirstScreen}
                  className='reset'
                  aria-label='Reset form'
                >
                  Start Over
                </button>
              </div>
              <a
                href='https://legal.brown-forman.com/terms-of-use/english/'
                target='_blank'
                className='legal-link'
              >
                View our terms of use
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

Footer.propTypes = {
  resetToFirstScreen: PropTypes.func.isRequired, // Validate as a function
};
